import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Minus, Plus } from "lucide-react";

const AfterOccurrencesStepper = ({ value, max, onChange, disabled }) => {
  const safeValue = Number.isFinite(value) ? value : 1;
  const [text, setText] = useState(String(safeValue));

  useEffect(() => {
    setText(String(safeValue));
  }, [safeValue]);

  const clamp = (n) => Math.min(Math.max(n, 1), Math.max(max, 1));

  const commit = (raw) => {
    const parsed = parseInt(raw, 10);
    const next = Number.isFinite(parsed) ? clamp(parsed) : safeValue;
    setText(String(next));
    if (next !== safeValue) onChange(next);
  };

  return (
    <Wrapper disabled={disabled}>
      <StepButton
        type="button"
        onClick={() => commit(safeValue - 1)}
        disabled={disabled || safeValue <= 1}
      >
        <Minus size={12} />
      </StepButton>
      <StepInput
        value={text}
        disabled={disabled}
        onChange={(e) => setText(e.target.value.replace(/[^0-9]/g, ""))}
        onBlur={(e) => commit(e.target.value)}
      />
      <StepButton
        type="button"
        onClick={() => commit(safeValue + 1)}
        disabled={disabled || safeValue >= max}
      >
        <Plus size={12} />
      </StepButton>
    </Wrapper>
  );
};

export default AfterOccurrencesStepper;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border-radius: 10px;
  padding: 4px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

const StepButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  color: ${({ theme }) => theme.menu.primaryTextColor};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const StepInput = styled.input`
  width: 36px;
  text-align: center;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 14px;
  font-weight: 600;

  &:focus-visible {
    outline: none;
  }
`;
